// src/components/HeroSection.js
import React from 'react';
import '../../styles/CustomerSiteStyles/HeroSection.css';

function HeroSection() {
  return (
    <section className="hero-section">
      <div className="hero-overlay">
        <div className="hero-content">
          <p>
            <strong>Affordable Roofing + Solar Solutions | Job Done Right</strong>
            <br />
            <br />
            Founded in Louisville, KY and now serving homeowners and businesses across Kentucky, Oklahoma, Nebraska, Missouri, and Kansas — we provide residential and commercial roofing services including roof replacements, gutters, siding and more. With industry-leading training, expert attention to detail, and responsive service, you can trust Affordable Roofing + Solar Solutions to help you get a job done right.
          </p>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;

